import { PUBLIC_REDUCED_LAYOUT, PUBLIC_MENU_LAYOUT } from '@/constants/layouts'
import i18n from '@/plugins/i18n'

export default [
  {
    name: 'Error.NotFound',
    path: 'error/not-found',
    component: () => import('@/components/views/errors/NotFoundErrorPage'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text () {
          return i18n.t('page-not-found')
        }
      }
    }
  },
  {
    name: 'Error.Unauthorized',
    path: 'error/unauthorized',
    component: () => import('@/components/views/errors/UnauthorizedErrorPage'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
			fullWidthLayout: true,
      title: {
        text () {
          return i18n.t('base.errors.unauthorized.title')
        },
				hide: true
      }
    }
  },
  {
    name: 'Error.Unauthorized360',
    path: 'error/unauthorized/360',
    component: () => import('@/components/views/errors/Unauthorized360AccessErrorPage'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text () {
          return i18n.t('base.errors.unauthorized.title360')
        }
      }
    }
  },
  {
    name: 'Error.UnauthorizedTravel',
    path: 'error/unauthorized/travel',
    component: () => import('@/components/views/errors/UnauthorizedTravelErrorPage'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      title: {
        text () {
          return i18n.t('base.errors.unauthorized.title')
        }
      }
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/routes/error.routes.js